import React, { useEffect, useRef, useState } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { eventuallyInsertReevooScript } from "../utility/reevoo";
import classNames from "classnames";
import { insertBazaarVoiceScript } from "../utility/bazaar-voice";

const ReevooEmbeddable = ({ productId, /* productLink, */ parent = false, origin }) => {
  const containerRef = useRef();

  const {
    config: { reevoo },
    labelManagerLabels,
  } = useStaticQuery(graphql`
    {
      labelManagerLabels {
        activateReevoo
      }
      config: liferayGeneralConfiguration {
        reevoo: isReevooActiveFieldSet {
          isReevooActive
          isBazaarVoiceActive
        }
      }
    }
  `);

  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const container = containerRef.current;
    if (
      container &&
      productId &&
      (!!reevoo?.isReevooActive?.length || !!reevoo?.isBazaarVoiceActive?.length)
    ) {
      if (!!reevoo?.isReevooActive?.length) {
        eventuallyInsertReevooScript();
      }

      if (!!reevoo?.isBazaarVoiceActive?.length) {
        insertBazaarVoiceScript();
      }

      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === "childList") {
            // console.log('A child node has been added or removed.');
            const { addedNodes } = mutation;
            if (addedNodes?.length) {
              // for (const elem of addedNodes) {
              // console.log("added node", elem);
              setLoaded(true);
              // }
            }
          }
        }
      });
      // Start observing the target node for configured mutations
      observer.observe(container, { childList: true });
      // Later, you can stop observing

      const attachShadowListener = (event) => {
        if (event.detail.element === container) {
          setLoaded(true);
        }
      };
      document.addEventListener("attach-shadow", attachShadowListener);
      return () => {
        observer.disconnect();
        document.removeEventListener("attach-shadow", attachShadowListener);
      };
    }
  }, [productId, reevoo]);

  return (
    <div>
      {!!reevoo?.isReevooActive?.length && (
        <div
          ref={containerRef}
          id="feefo-product-review-widgetId"
          className={classNames("feefo-review-widget-product", origin === "plp" && "reevoo-plp")}
          data-product-sku={parent ? undefined : productId}
          data-parent-product-sku={parent ? productId : undefined}
        />
      )}
      {!reevoo?.isReevooActive?.length && !!reevoo?.isBazaarVoiceActive?.length && (
        <div>
          <div
            data-bv-show="rating_summary"
            data-bv-product-id={productId}
            /* data-bv-redirect-url={productLink} */
          ></div>
          <div
            ref={containerRef}
            data-bv-show="reviews"
            data-bv-product-id={productId}
            /* data-bv-redirect-url={productLink} */
          ></div>
        </div>
      )}
      {!loaded && <p className="text-center py-3">{labelManagerLabels.activateReevoo}</p>}
    </div>
  );
};

export default React.memo(ReevooEmbeddable);
